import { SvgSprites } from './svg-sprites';
//import CommentsWidgetSVG from './comments-widget';
import svgParser from './svg-parser';
const GlobalSvgSprites = new SvgSprites();
GlobalSvgSprites.el.setAttribute("id","qna-lib-svg-sprites");
GlobalSvgSprites.el.style.display = "none";
document.body.appendChild(GlobalSvgSprites.el);
export { GlobalSvgSprites }